import { type FC } from 'react'
import classNames from 'classnames'
import { type Location, MeetingMode } from '../../../../models/Scheduling'

interface PlaceToggleCardsProps {
  meetingMode: MeetingMode
  defaultLocation?: Location
  onChange: (meetingMode: MeetingMode, locationId?: string) => void
}

const cardClassName = (isSelected: boolean): string =>
  classNames(
    'd-flex align-items-center justify-content-center zocks-gap-0.5 bold p-3 rounded flex-grow-1 zocks-bg-color-white',
    isSelected ? 'zocks-border-primary zocks-text-primary' : 'border zocks-border-color-gray-200 zocks-text-gray-600',
  )

// "Set the place" — Virtual / In-person toggle cards
export const PlaceToggleCards: FC<PlaceToggleCardsProps> = ({ meetingMode, defaultLocation, onChange }) => (
  <div className='d-flex flex-column zocks-gap-0.25'>
    <label className='bold'>Set the place</label>
    <div className='d-flex gap-2'>
      <button type='button' className={cardClassName(meetingMode === MeetingMode.VIRTUAL)} onClick={() => onChange(MeetingMode.VIRTUAL, undefined)}>
        <i className='bi bi-camera-video' />
        Virtual
      </button>
      <button
        type='button'
        className={cardClassName(meetingMode === MeetingMode.IN_PERSON)}
        onClick={() => onChange(MeetingMode.IN_PERSON, defaultLocation?.id)}
      >
        <i className='bi bi-people' />
        In-person
      </button>
    </div>
  </div>
)
